enum WorkspaceProjectUtilityUnitOfMeasurementDirection {
  'More is an improvement' = 'More is an improvement',
  'Less is an improvement' = 'Less is an improvement',
}

export default WorkspaceProjectUtilityUnitOfMeasurementDirection
